import React from 'react'
import classes from './Loader.module.scss'

const LoadingComponent = () => (
  <div className={classes.ripple}>
    <div />
    <div />
  </div>
)

export default LoadingComponent
